import Vue from 'vue';
import Vuex from 'vuex';
import env from '@/store/modules/env';
import user from '@/store/modules/user';
import aiGame from '@/store/modules/aiGame';
import tsumeGame from '@/store/modules/tsumeGame';
import verification from '@/store/modules/verification';
import course from '@/store/modules/course';
import pvp from '@/store/modules/pvp';
import liveCourse from '@/store/modules/liveCourse';
import notification from '@/store/modules/notification';
import maintenance from '@/store/modules/maintenance';
import teacherManagement from '@/store/modules/teacherManagement';
import aiChat from '@/store/modules/aiChat';
import multimediaClassroom from '@/store/modules/multimediaClassroom';
import ladder from '@/store/modules/ladder';
import weeklyTsume from '@/store/modules/weeklyTsume';
import popup from '@/store/modules/popup';
import product from '@/store/modules/product';
import userRecord from '@/store/modules/userRecord';
import npc from '@/store/modules/npc';
import courseVideo from '@/store/modules/courseVideo';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    env,
    user,
    aiGame,
    tsumeGame,
    verification,
    course,
    pvp,
    liveCourse,
    notification,
    maintenance,
    teacherManagement,
    aiChat,
    multimediaClassroom,
    ladder,
    weeklyTsume,
    popup,
    product,
    userRecord,
    npc,
    courseVideo,
  },
});
